export const strCmp = (a: string, b: string) => (a > b ? 1 : a < b ? -1 : 0);
